<script lang="ts" setup></script>
<template>
    <div>
        <H1Heading class="text-4xl text-red-700">Terms of Use</H1Heading>
        <div class="py-6">
            <p class="mb-8 text-gray-500 italic">
                By clicking "I accept" or "I agree" to these terms and conditions (“terms”) or using, accessing, or
                registering for AmericanBookCompany (American Book Company Inc.) (collectively, “we,” “us,” "ABC," or
                AmericanBookCompany), or any other websites, applications, or online services that link to these terms
                you are agreeing to these terms, which is a binding contract with American Book Company, Inc.
            </p>

            <p class="mb-4">
                Please read these terms carefully. To protect our rights and yours, these terms govern all uses of
                AmericanBookCompany.
            </p>

            <p class="mb-4">
                Access or use of AmericanBookCompany eBooks and Online Testing materials which you have purchased
                constitutes acceptance of these terms as a binding agreement. By using AmericanBookCompany, you
                represent that you: (1) you are an adult (according to the rules of the country where you are located),
                (2) have read and understood these terms; (3) agree to use AmericanBookCompany in compliance with
                applicable laws and these terms; (4) are an authorized user; and (5) that you will be responsible for
                ensuring that any student user authorized by you to use and access AmericanBookCompany does so in
                accordance with these terms.
            </p>

            <p class="mb-4">
                Furthermore, if you are an educator, regardless of teaching at a private or public Institution, you
                represent and warrant to us that you are authorized to agree to these terms on behalf of your
                organization and that you provide consent on behalf of your students.
            </p>

            <p class="mb-4">
                Unauthorized commercial, corporate or other misuse of AmericanBookCompany may result in the cancellation
                of your account.
            </p>

            <p class="mb-4">
                AmericanBookCompany and American Book Company, Inc. comply with applicable law, including the Family
                Educational Rights and Privacy Act (FERPA) and Children's Online Privacy Protection Act (COPPA). We rely
                on consent by the educator as the basis for collecting information via the student account feature. If
                you are a parent, guardian, or teacher and believe that your child or student under the age of 18 has
                provided American Book Company, Inc. with personally identifiable information without your consent,
                please notify us at contact@americanbookcompany.com so that we can promptly delete the information from
                our servers. For more information about our privacy policy,
                <a
                    href="/privacy-policy"
                    target="_blank"
                    >please read.</a
                >
            </p>

            <p class="mb-4">
                If you have any questions about how to use AmericanBookCompany, please contact us at:
                <a href="mailto:contact@americanbookcompany.com">contact@americanbookcompany.com</a>
                or visit
                <a href="mailto:help.AmericanBookCompany.com">help.AmericanBookCompany.com</a>
                . These terms, in addition to our Privacy Policy, are the contract between you and American Book
                Company, Inc. If you don't agree to these terms, don't use AmericanBookCompany. If you break these
                rules, we reserve the right to cancel your subscription.
            </p>

            <p class="mb-4">
                There are two kinds of users: teachers and students (i.e. those who access AmericanBookCompany via codes
                or via a student account provided by their school/district administrator). By registering for
                AmericanBookCompany you're representing that you're an adult, that you have the ability to and, in fact,
                do provide consent for the child(ren) to use AmericanBookCompany, and that any child(ren) who uses
                AmericanBookCompany at your direction will follow these terms.
            </p>

            <p class="mb-4">
                You're promising that if you're representing a school or district, you're able to agree to these terms
                on behalf of your organization and provide consent on behalf of students. You're designating us a school
                official as defined by FERPA. Our COPPA-required verifiable consent is obtained from teachers.
            </p>

            <p class="mb-4">
                Access to AmericanBookCompany resources via automatically-generated codes pair one student with one
                resource. You will not assign the same code to two or more students.
            </p>

            <p class="mb-4">
                You will not share your password, nor will you allow or encourage your students to share passwords.
            </p>

            <p class="mb-4">
                We own all AmericanBookCompany content, or have the right to use third-party materials that we license,
                such as photographs. Using, sharing, distributing, or otherwise accessing AmericanBookCompany in a way
                that is not allowed by AmericanBookCompany and American Book Company is a violation of these terms.
                Content means all the text, graphics, user interfaces, visual interfaces, photographs, logos, sounds,
                music, artwork, assessments, pictures, video, audio clips, trademarks, trade names, service marks,
                computer code displayed on or available through AmericanBookCompany as well as the design, layout,
                arrangement and appearance of our platform. Reproduction of AmericanBookCompany content is prohibited.
                American Book Company, Inc. owns all legal rights, title, and interest in AmericanBookCompany, including
                any intellectual property rights, whether those rights are registered or not, and wherever in the world
                those rights may exist, subject to the rights of third-parties from whom American Book Company licenses
                content.
            </p>

            <p class="mb-4">
                When you pay for access to use AmericanBookCompany, you do not own the content therein. We grant you a
                license to use AmericanBookCompany for the term of your agreement. Except as expressly permitted in
                these terms, or with American Book Company, Inc.’s prior written consent, no part of AmericanBookCompany
                may be used, copied, reproduced, distributed, uploaded, posted, publicly displayed, translated,
                transmitted, sold, licensed, or otherwise used for any reason whatsoever.
            </p>

            <p class="mb-4">
                You will not sell, try to sell, or reverse engineer AmericanBookCompany content. Additionally, you agree
                not to try to scrape our website or use external forces to try to interfere with AmericanBookCompany,
                and you agree not to bypass or attempt to bypass any bot exclusion measures we may put in place.
            </p>

            <p class="mb-4">
                You may, at your initiative or at our request, share feedback or ideas with us regarding
                AmericanBookCompany, including but not limited to survey feedback or article improvement feedback on our
                Knowledge Base. If you choose to share your feedback with us, you understand that we are not required to
                take any action based on your feedback, or if we do take action based on your feedback, you will have no
                expectation of review, approval, payment, or consideration of any type for any such feedback or ideas
                and American Book Company will be free to use the feedback or ideas in our sole and absolute discretion.
            </p>

            <p class="mb-4">
                Changes to these terms and conditions:<br />
                American Book Company may make modifications, deletions and/or additions to these terms and conditions
                at any time. Changes will be effective thirty (30) days after American Book Company provides notice of
                the changes, whether such notice is posted to AmericanBookCompany.com or is sent to the email address
                associated with your account, or when you opt in or otherwise expressly agree to the changes or to a
                version of these terms and conditions incorporating the changes, whichever comes first.
            </p>

            <p class="mb-4">
                Under these terms and conditions, you consent to receive communications from American Book Company
                electronically.
            </p>
        </div>
    </div>
</template>
